import { useCallback } from 'react';
import { preload } from 'swr';
import { api } from '../lib/api';
import { useRegion } from './useRegion';
import { getProductKey } from '../utils/ssr-to-swr';
import { getStableClientRegionId } from '../utils/clientRegionId';

function resolveRegionId(getRegionId: () => number | null): number | undefined {
  return getRegionId() ?? getStableClientRegionId() ?? undefined;
}

/**
 * Предзагрузка карточки товара при наведении / pointerdown.
 * Пишет в тот же SWR-ключ, что и страница товара.
 */
export function usePrefetchProduct() {
  const { getRegionId } = useRegion();

  return useCallback(
    (slug: string) => {
      if (!slug) return;

      const regionId = resolveRegionId(getRegionId);
      const key = getProductKey(slug, { region_id: regionId });

      void preload(key, () => api.products.get(slug, { region_id: regionId }));
    },
    [getRegionId],
  );
}
